import { pad2 } from "@web/lib/time";
import { useEffect, useState } from "react";

export function UtcClock({ className }: { className?: string }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const h = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(h);
  }, []);
  return (
    <span className={className}>
      <span className="tabular">
        {pad2(now.getUTCHours())}:{pad2(now.getUTCMinutes())}
      </span>{" "}
      UTC
    </span>
  );
}
